module.exports = __webpack_public_path__ + "static/media/u23a-c_14.a576ff53.mp3";